import axios from 'axios';

export default axios.create({
  baseURL: "https://g-axon.work/jwtauth/api",
  headers: {
    'Content-Type': 'application/json',
  }
});
